import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import Paper from "@mui/material/Paper";
import classes from "../../styles/DashboardView.module.css";
import { CourseCountCompare } from "../../utilities/dashboardAggregations";
import { YoYLegend, lightenMetricColor } from "./YoYLegend";
import { IndexBadge } from "./IndexBadge";

interface TopCoursesCountChartProps {
    data: CourseCountCompare[];
    currentYearLabel: string;
    prevYearLabel: string;
}

const COLOR = "#1976d2";
const PREV_COLOR = lightenMetricColor(COLOR);

export function TopCoursesCountChart({ data, currentYearLabel, prevYearLabel }: TopCoursesCountChartProps) {
    if (!data || data.length === 0) {
        return (
            <Paper className={classes.chartCard} elevation={2}>
                <div className={classes.chartTitle}>Top 10 kurser (tilmeldinger)</div>
                <p>Ingen data</p>
            </Paper>
        );
    }

    return (
        <Paper className={classes.chartCard} elevation={2}>
            <div className={classes.chartHeader}>
                <h3 className={classes.chartTitle}>Top 10 kurser (tilmeldinger)</h3>
                <YoYLegend currentColor={COLOR} prevColor={PREV_COLOR} currentYearLabel={currentYearLabel} prevYearLabel={prevYearLabel} />
            </div>
            <ResponsiveContainer width="100%" height={Math.max(360, data.length * 44)}>
                <BarChart data={data} layout="vertical" margin={{ left: 20 }} barCategoryGap="22%">
                    <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
                    <XAxis type="number" tick={{ fontSize: 12 }} />
                    <YAxis type="category" dataKey="title" width={200} interval={0}
                        tick={({ x, y, payload }: any) => {
                            const label = payload.value.length > 30 ? payload.value.substring(0, 30) + "..." : payload.value;
                            return <text x={x} y={y} dy={4} textAnchor="end" fontSize={11} fill="#5f6368">{label}</text>;
                        }}
                    />
                    <Tooltip content={({ active, payload }: any) => {
                        if (!active || !payload || !payload[0]) return null;
                        const d: CourseCountCompare = payload[0].payload;
                        return (
                            <div style={{ background: "white", border: "1px solid #ccc", padding: 10, borderRadius: 4, maxWidth: 320 }}>
                                <div style={{ fontWeight: 600, marginBottom: 6 }}>{d.title}</div>
                                <div style={{ fontSize: 13, color: COLOR, fontWeight: 600 }}>{currentYearLabel}: {d.current} tilmeldinger</div>
                                <div style={{ fontSize: 12, color: PREV_COLOR, fontWeight: 600 }}>{prevYearLabel}: {d.previous} tilmeldinger</div>
                                <IndexBadge current={d.current} previous={d.previous} />
                            </div>
                        );
                    }} />
                    <Bar dataKey="previous" fill={PREV_COLOR} radius={[0, 3, 3, 0]} />
                    <Bar dataKey="current" fill={COLOR} radius={[0, 3, 3, 0]} />
                </BarChart>
            </ResponsiveContainer>
        </Paper>
    );
}
